import React, { useContext, useState } from 'react'
import { Image } from 'react-native'
import { TakePhoto } from '../../../../../components/TakePhoto'
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { NecropsyRoutes } from '../../../../../navigator/types'
import { NecropsyContext } from '../../../../../context/Necropsy/Provider'
import { AlertMessage } from '../../../../../components/AlertMessage'
import { useTranslation } from 'react-i18next'

interface NavigationParams extends StackNavigationProp<NecropsyRoutes, 'ExternalPhoto'> {}

export const ExternalPhoto = () => {
  const { setSinglePhoto } = useContext(NecropsyContext)
  const { t } = useTranslation()
  const navigation = useNavigation<NavigationParams>()
  const route = useRoute<RouteProp<NecropsyRoutes, 'ExternalPhoto'>>()
  const [showAlert, setShowAlert] = useState(false)

  const [photo, setPhoto] = useState('')

  const handleNavigate = () => {
    setSinglePhoto('externalPhoto', {
      uri: photo,
    })
    navigation.replace(route.params?.returnToSummary ? 'Summary' : 'GillPhoto')
  }

  return (
    <>
      {!showAlert && (
        <TakePhoto
          getPhoto={(uri) => {
            setPhoto(uri)
            setShowAlert(true)
          }}
          capturingText={t('FOTO SALMÓN EXTERNA')}
          indicationsText={t('Sitúe el pescado completo dentro del margen')}
        />
      )}

      {showAlert && (
        <AlertMessage
          title={t('Foto tomada con éxito')}
          cancelLabel={t('Repetir foto')}
          successLabel={t('Continuar')}
          action={() => {
            handleNavigate()
          }}
          cancelButton
          style={{ position: 'absolute' }}
          actionCancelButton={() => setShowAlert(false)}
        >
          <Image
            source={{ uri: photo }}
            style={{ width: '100%', height: 500, borderRadius: 8 }}
            resizeMode='contain'
          />
        </AlertMessage>
      )}
    </>
  )
}
